<template>
  <div class="shopItemList">
    <div class="listSearch">
      <div class="search">
        <button type="button" class="btn btnRed" :disabled="checkedItems <= 0">
          선택 아이템
          <span v-if="checkedItems > 0">({{ checkedItems }})</span>
          삭제
        </button>
        <input type="text" class="input sizeL" :placeholder="locale.search_placeholder" v-model="searchInput">
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="setDetail('new')">아이템 추가</button>
        <button type="button" class="btn btnWhite">외부 데이터 연동</button>
      </div>
    </div>
    <div class="listTable">
      <table>
        <thead>
          <tr>
            <th>
              <span class="checkbox">
                <input type="checkbox" id="check_all">
                <label for="check_all"></label>
              </span>
            </th>
            <th>상품명</th>
            <th>식별코드</th>
            <th>판매가</th>
            <th>등록방법</th>
            <th>등록일시</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(cnt, index) in 2"
            :key="index">
            <td class="check">
              <span class="checkbox">
                <input type="checkbox" name="check_item" :id="`check_item_${index}`">
                <label :for="`check_item_${index}`"></label>
              </span>
            </td>
            <td class="name" @click="setDetail('1')">
              <span class="sync"></span>페퍼로니 피자
            </td>
            <td class="name" @click="setDetail('1')">P0001</td>
            <td>{{ priceFormat(10000) }}</td>
            <td>SanhaPOS</td>
            <td class="date">2025-01-01 12:00:00</td>
            <td class="btns">
              <button type="button" class="btn btnWhite sizeS">{{ locale.copy }}</button>
              <button type="button" class="btn btnRed sizeS">{{ locale.delete }}</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <CreateItem
      v-if="detail"
      :locale="locale"
      :shopPageId="id"
      :shopItemId="detail"
      @close="setDetail(null)" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LANG from '@/common/lang'
import regExp from '@/common/regExp'
import CreateItem from './CreateItem'

export default {
  name: 'ShopItem',
  props: [
    'locale',
    'isLayer' // 직접 편집 X
  ],
  components: {
    CreateItem
  },
  computed: {
    checkedItems () {
      return this.checked && this.checked.length
    }
  },
  created () {
    this.init()
  },
  mounted () {
  },
  data () {
    return {
      searchInput: '',
      checked: [],
      list: [],
      detail: null,
      createItem: false
    }
  },
  methods: {
    async init () {
      
    },
    priceFormat (price) {
      const currency = this.$store.getters['setting/getCurrencyCode']
      const disabledSymbol = this.$store.getters['setting/getData']?.currency?.disabledCurrencySymbol ?? false
      return price ? regExp.priceFormat(price, code.toUpperCase(), disabledSymbol) : ''
    },
    setDetail (shopItemId) {
      this.detail = shopItemId
    }
  }
}
</script>
